import { defineMessages } from 'react-intl';

const messages = defineMessages({
  editEventCreateEvent: {
    id: 'collegeevents.events.edit.create.event',
    defaultMessage: 'Create Event',
  },
  editEventEditEvent: {
    id: 'collegeevents.events.edit.edit.event',
    defaultMessage: 'Edit Event',
  },
  editEventViewDetails: {
    id: 'collegeevents.events.view.details.event',
    defaultMessage: 'View Event Details',
  },
  editEventDuplicateEvent: {
    id: 'collegeevents.events.edit.duplicate.event',
    defaultMessage: 'Duplicate Event',
  },
  editEventDetails: {
    id: 'collegeevents.events.edit.details',
    defaultMessage: 'EVENT DETAILS',
  },
  editEventName: {
    id: 'collegeevents.events.edit.name',
    defaultMessage: 'Event Name',
  },
  editEventDateTime: {
    id: 'collegeevents.events.edit.datetime',
    defaultMessage: 'Event Date/Time',
  },
  editEventDateDay: {
    id: 'collegeevents.events.edit.date.day',
    defaultMessage: 'Event Date Day',
  },
  editEventTimezone: {
    id: 'collegeevents.events.edit.timezone',
    defaultMessage: 'Timezone',
  },
  editEventDescription: {
    id: 'collegeevents.events.edit.description',
    defaultMessage: 'Description',
  },
  editEventRegistrationURL: {
    id: 'collegeevents.events.edit.registration.url',
    defaultMessage: 'Registration URL',
  },
  editEventDeadline: {
    id: 'collegeevents.events.edit.deadline',
    defaultMessage: 'RSVP Deadline',
  },
  editEventDisplayIn: {
    id: 'collegeevents.events.edit.display.in',
    defaultMessage: 'Display In',
  },
  editEventDisplayInNaviance: {
    id: 'collegeevents.events.edit.display.in.naviance',
    defaultMessage: 'Naviance',
  },
  editEventDisplayInCamino: {
    id: 'collegeevents.events.edit.display.in.camino',
    defaultMessage: 'Camino',
  },
  editEventLocation: {
    id: 'collegeevents.events.edit.location',
    defaultMessage: 'EVENT LOCATION',
  },
  editEventContact: {
    id: 'collegeevents.events.edit.contact',
    defaultMessage: 'EVENT PRIMARY CONTACT',
  },
  editEventFilter: {
    id: 'collegeevents.events.edit.filter',
    defaultMessage: 'EVENT AUDIENCE',
  },
  editEventSave: {
    id: 'collegeevents.events.edit.save',
    defaultMessage: 'SAVE DRAFT',
  },
  editEventPublish: {
    id: 'collegeevents.events.edit.publish',
    defaultMessage: 'PUBLISH NOW',
  },
  editEventUpdate: {
    id: 'collegeevents.events.edit.update',
    defaultMessage: 'UPDATE',
  },
  tabEdit: {
    id: 'collegeevents.events.edit.tab.edit',
    defaultMessage: 'EDIT',
  },
  tabDetails: {
    id: 'collegeevents.events.edit.tab.details',
    defaultMessage: 'DETAILS',
  },
  tabAttendees: {
    id: 'collegeevents.events.edit.tab.attendees',
    defaultMessage: 'ATTENDEES',
  },
  editEventEnterName: {
    id: 'collegeevents.events.edit.enter.name',
    defaultMessage: 'Please enter a name for the event (less than or equal to 120 characters).',
  },
  editEventEnterEventDate: {
    id: 'collegeevents.events.edit.enter.event.date',
    defaultMessage: 'Please enter a valid event date.',
  },
  editEventStartTime: {
    id: 'collegeevents.events.edit.enter.start.time',
    defaultMessage: 'Please enter a valid start time for the event.',
  },
  editEventEndTime: {
    id: 'collegeevents.events.edit.enter.end.time',
    defaultMessage: 'Please enter a valid end time for the event.',
  },
  editEventEnterDeadlineTime: {
    id: 'collegeevents.events.edit.enter.deadline.time',
    defaultMessage: 'Please enter a valid RSVP deadline time.',
  },
  editEventEnterDisplayIn: {
    id: 'collegeevents.events.edit.enter.display.in',
    defaultMessage: 'Please select where this event should be displaying.',
  },
  editEventSelectContact: {
    id: 'collegeevents.events.edit.select.contact',
    defaultMessage: 'Please select a contact for the event.',
  },
  editEventSelectLocation: {
    id: 'collegeevents.events.edit.select.location',
    defaultMessage: 'Please select a location for the event.',
  },
  editEventRegistrationUrl: {
    id: 'collegeevents.events.edit.enter.registration.url',
    defaultMessage: 'Please enter a valid registration URL.',
  },
  editEventSelectDates: {
    id: 'collegeevents.events.edit.select.dates',
    defaultMessage: 'RSVP Deadline date and time must be on or before Event Start date and time',
  },
  editEventSelectFuture: {
    id: 'collegeevents.events.edit.select.future',
    defaultMessage: 'Event Start date and time must not be in the past',
  },
  editEventSelectFutureReg: {
    id: 'collegeevents.events.edit.select.future.reg',
    defaultMessage: 'Event RSVP Deadline date and time must not be in the past',
  },
  editEventError: {
    id: 'collegeevents.events.edit.error',
    defaultMessage: 'There was an error processing this event, please try again',
  },
  cancel: {
    id: 'collegeevents.events.create.cancel',
    defaultMessage: 'Cancel',
  },
  cancelTitle: {
    id: 'collegeevents.events.cancel.title',
    defaultMessage: 'Are you sure you want to cancel?',
  },
  cancelSubtitle: {
    id: 'collegeevents.events.cancel.subtitle',
    defaultMessage: "Any changes you've made to this event will not be saved.",
  },
  cancelConfirmButton: {
    id: 'collegeevents.events.cancel.confirm.button',
    defaultMessage: "Don't Save",
  },
  cancelRejectButton: {
    id: 'collegeevents.events.cancel.reject.button',
    defaultMessage: 'Continue Editing',
  },
});

export default messages;
